import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import Toggle from './ui/toggle';
import getCategoryNames from '../../../../api/graphql/queries/getCategoryNames';
import UISelectValue from './ui/UISelectValue';
import slugify from '../../../../utils/slugify';
import { toSelectOptions, fromSelectOptions } from '../../../../utils/selectStringOptions';

const DEFAULT_ITEMS_PER_ROW_PER_MEDIA_QUERY = {
  desktop: 3,
  tablet: 3,
  mobile: 2,
};

const ITEMS_VALUES = {
  desktop: [
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
  ],
  tablet: [
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
  ],
  mobile: [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
  ],
};

const MEDIA_VALUES = [
  { value: 'desktop', label: 'Desktop' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'tablet', label: 'Tablet' },
];

const LAYOUT_VALUES = [
  { value: false, label: 'None' },
  { value: 'discos', label: 'Records' },
  { value: 'magazine', label: 'Magazine' },
  { value: 'curatedList', label: 'Curated List' },
  { value: 'noticias', label: 'News' },
  { value: 'mainNews', label: 'News Main' },
  { value: 'smallPictures', label: 'Small pics' },
  { value: 'smallPicturesTextInWhite', label: 'Small pics-White' },
  { value: 'festival', label: 'Festivales' },
  { value: 'tour', label: 'Tours' },
  { value: 'news', label: 'Noticias new design' },
];

const initialState = {
  type: 'GroupedItems',
  components: [{
    type: 'Launcher2',
    findCategory: [],
    quantity: 3,
    rows: 1,
    layout: false,
    scrollable: false,
  }],
  bgColor: '#FFFFFF',
  color: '#000000',
  title: {
    en: '',
  },
  itemsPerRowPerMediaQuery: DEFAULT_ITEMS_PER_ROW_PER_MEDIA_QUERY,
};

const GroupedItems = ({
  activeLanguage,
  handlerSetComponents,
  components,
  languages,
  id,
  reusableComponent,
  reusableComponentSlugname,
  slider,
}) => {
  const launcherInitialState = {
    content: 'Launcher2',
    readableName: 'Launcher',
    component: {
      type: 'Launcher2',
      findCategory: [],
      slugNames: [],
      quantity: 9,
      rows: 1,
      showLoadMore: false,
      mustBeSingle: false,
      isTours: false,
      isNews: false,
      showAll: false,
      hasFilters: false,
    },
  };

  const ChooseCategory = ({
    label = '',
    setValue,
    value,
  }) => (
    <div className="w-full">
      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{label}</label>
      <AsyncSelect
        className="appearance-none block css-2b097c-container focus:bg-white focus:border-gray-500 focus:outline-none leading-tight pb-3 rounded text-black text-black"
        loadOptions={loadCategoryNames}
        value={toSelectOptions(value)}
        isMulti
        cacheOptions
        onChange={selected => setValue(fromSelectOptions(selected))}
      />
    </div>
  );

  const InputValue = ({
    label = '',
    setValue,
    value,
  }) => (
    <div className="w-full">
      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{label}</label>
      <input
        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
        type="text"
        onChange={e => setValue(e.target.value)}
        value={value}
      />
    </div>
  );

  const filterCategoryNames = (categorySearch = '') => {
    if (categorySearch === '') categorySearch = 'a';
    return getCategoryNames(categorySearch)
      .then((res) => {
        console.log('🚀 ~ file: GroupedItems.jsx ~ line 99 ~ .then ~ res', res);
        if (res) {
          return toSelectOptions(res.map(o => slugify(o.postName)));
        }
      })
      .catch(err => console.log(err, ' => getCategoryNames'));
  };

  const loadCategoryNames = inputValue => new Promise((resolve) => {
    resolve(filterCategoryNames(inputValue));
  });


  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const [title, setTitle] = useState({ en: '' });
  const [bgColor, setBgColor] = useState('#ffffff');
  const [color, setColor] = useState('#000000');
  const [mediaQuery, setMediaQuery] = useState('desktop');
  const [itemsPerRowPerMediaQuery, setItemsPerRowPerMediaQuery] = useState(DEFAULT_ITEMS_PER_ROW_PER_MEDIA_QUERY);
  const [hasViewAll, setHasViewAll] = useState(false);
  const [hasViewAll_text, setHasViewAll_text] = useState({ en: '' });
  const [hasViewAll_link, setHasViewAll_link] = useState('');
  const [hasViewAll_arrow, setHasViewAll_arrow] = useState(false);

  const [launcherCategory, setLauncherCategory] = useState([]);
  const [launcherQuantity, setLauncherQuantity] = useState(3);
  const [launcherLayout, setLauncherLayout] = useState(false);
  const [launcherScrollable, setLauncherScrollable] = useState(false);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);

      if (component) {
        const {
          title: currentTitle,
          bgColor: currentBgColor,
          color: currentColor,
          hasViewAll: currentHasViewAll,
          components: currentComponents,
          itemsPerRowPerMediaQuery: currentItemsPerRowPerMediaQuery,
        } = component;

        setState(component);
        setTitle(currentTitle);
        setBgColor(currentBgColor);
        setColor(currentColor);
        setItemsPerRowPerMediaQuery(currentItemsPerRowPerMediaQuery || DEFAULT_ITEMS_PER_ROW_PER_MEDIA_QUERY);

        if (currentHasViewAll) {
          setHasViewAll(true);
          setHasViewAll_arrow(currentHasViewAll.arrow || false);
          setHasViewAll_text(currentHasViewAll.text || { en: '' });
          setHasViewAll_link(currentHasViewAll.link || '');
        }

        if (currentComponents && currentComponents[0]) {
          setLauncherCategory(currentComponents[0].findCategory);
          setLauncherQuantity(currentComponents[0].quantity);
          setLauncherLayout(currentComponents[0].layout);
          setLauncherScrollable(currentComponents[0].scrollable);
        }
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);
  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);

    const construction = {
      type: state.type,
      compId: state.compId || '',
      title,
      bgColor,
      color,
      itemsPerRowPerMediaQuery,
      components: [{
        type: 'Launcher2',
        compId: `Launcher2_${id}`,
        findCategory: launcherCategory,
        quantity: parseInt(launcherQuantity),
        layout: launcherLayout === 'false' ? false : launcherLayout,
        scrollable: launcherScrollable,
        // Defaults
        rows: 1,
        showLoadMore: false,
        mustBeSingle: false,
        isTours: false,
        isNews: false,
        showAll: false,
        hasFilters: false,
        slugNames: [],
      }],
    };

    console.log('🚀 ~ file: GroupedItems.jsx ~ line 210 ~ useEffect ~ launcherCategory', launcherCategory);
    construction.hasViewAll = hasViewAll ? {
      text: { ...hasViewAll_text },
      arrow: hasViewAll_arrow,
      link: hasViewAll_link || '',
    } : false;

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    title,
    bgColor,
    color,
    itemsPerRowPerMediaQuery,
    hasViewAll,
    hasViewAll_arrow,
    hasViewAll_text,
    hasViewAll_link,
    launcherCategory,
    launcherQuantity,
    launcherLayout,
    launcherScrollable,
  ]);

  const titleChange = (e) => {
    title[activeLanguage] = e.target.value;
    setTitle({ ...title });
  };

  const hasViewAll_textChange = (e) => {
    hasViewAll_text[activeLanguage] = e.target.value;
    setHasViewAll_text({ ...hasViewAll_text });
  };

  const itemRowSelectorHandler = (e) => {
    const items = { ...itemsPerRowPerMediaQuery };
    items[mediaQuery] = Number(e.target.value);
    setItemsPerRowPerMediaQuery(items);
  };

  return (
    <>
      {/* <DragDropContext onDragEnd={onDragEnd}> */}
      <div className="flex justify-start flex-col text-black">
        {/* Single Form */}
        <div className="flex flex-wrap -mx-3">
          <div className="w-full md:w-full px-3 md:mb-0">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-first-name"
            >
              Title
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              type="text"
              onChange={titleChange}
              value={title[activeLanguage]}
            />
          </div>
        </div>
        {/* End */}
        {/* Double Color Form */}
        <div className="flex flex-wrap -mx-3">
          <div className="w-1/2 sm:w-full px-3 md:mb-0">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-first-name"
            >
              Text Color
            </label>
            <div className="relative">
              <input
                className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                type="text"
                onChange={e => setColor(e.target.value)}
                value={color}
              />
              <input
                className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                name="color"
                type="color"
                onChange={e => setColor(e.target.value)}
                value={color}
              />
            </div>
          </div>
          <div className="w-1/2 sm:w-full px-3 relative">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-last-name"
            >
              Background Color
            </label>
            <div className="relative">
              <input
                className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                onChange={e => setBgColor(e.target.value)}
                value={bgColor}
              />
              <input
                className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                name="color"
                type="color"
                onChange={e => setBgColor(e.target.value)}
                value={bgColor}
              />
            </div>
          </div>
        </div>
        {/* End */}
        <Toggle title={"DO YOU NEED A 'VIEW ALL LINK'?"} value={hasViewAll} setValue={setHasViewAll} />
      </div>
      {hasViewAll
          && (
          <>
            <div className="border-1 h-1px mb-6" />
            {/* Single Form */}
            <div className="flex flex-wrap -mx-3">
              <div className="w-3/4 px-3 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                >
                  Title for ...
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  type="text"
                  onChange={hasViewAll_textChange}
                  value={hasViewAll_text[activeLanguage]}
                />
              </div>
              <div className="px-3 md:mb-0">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Arrow
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    value={hasViewAll_arrow ? 'true' : 'false'}
                    onChange={e => setHasViewAll_arrow(e.target.value === 'true')}
                  >
                    <option value>Yes</option>
                    <option value={false}>No</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            {/* End */}
            {/* Single Form */}
            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-full px-3 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                >
                  Destination URL
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  type="text"
                  onChange={e => setHasViewAll_link(e.target.value)}
                  value={hasViewAll_link}
                />
              </div>
            </div>
          </>
          )
        }
      <div className="bg-blue-dark flex flex-wrap mt-4 p-4 rounded text-black text-white">
        <div className="flex w-full">
          <ChooseCategory label="Select Categories" setValue={setLauncherCategory} value={launcherCategory} />
        </div>
        <div className="flex">
          <InputValue label="Number of items to show" setValue={setLauncherQuantity} value={launcherQuantity} />
        </div>
        <div className="flex-1 pl-4">
          <UISelectValue
            label="Layout"
            setValue={setLauncherLayout}
            value={launcherLayout}
            options={LAYOUT_VALUES}
          />
        </div>
        <div className="flex flex-wrap items-end pl-4">
          <Toggle title="Will be scrollable" value={launcherScrollable} setValue={setLauncherScrollable} />
        </div>
        <div className="flex pl-4 pr-4">
          <UISelectValue
            label="Screen"
            setValue={setMediaQuery}
            value={mediaQuery}
            options={MEDIA_VALUES}
          />
        </div>
        <div>
          <UISelectValue
            onChange={itemRowSelectorHandler}
            value={itemsPerRowPerMediaQuery[mediaQuery]}
            label="Items per row"
            options={ITEMS_VALUES[mediaQuery]}
          />
        </div>
      </div>
    </>
  );
};

export default GroupedItems;
